// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__GLkvQ","header":"MessagesList_header__2rCMr","chat":"MessagesList_chat__sU2eX"};